<template>
  <div>
    <h2 class="text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6">
      We are here to reimagine...
    </h2>
    <div class="pl-5">
      <h3 v-if="!hasCompleted" class="text-n-gray-dark text-2xl font-hairline">
        Tell your desired audience what you are here to reimagine!
      </h3>
      <div class="text-n-gray-dark text-lg leading-org_edit_content font-hairline" v-else>
        {{organization.reimagine}}
      </div>
    </div>

    <div class="mt-6">
      <EventEditBtn :completed="hasCompleted" @click="modalOpen=true">
        Add your info
      </EventEditBtn>
    </div>
    <OrganizationReimagineModal v-model="modalOpen" />
  </div>
</template>

<script>
import OrganizationReimagineModal from "./modals/OrganizationReimagineModal.vue";
import PencilIcon from "../../../icons/PencilIcon.vue";
import EventEditBtn from "../event/EventEditBtn.vue";
export default {
  name: "OrganizationReimagine",
  components: {EventEditBtn, PencilIcon, OrganizationReimagineModal},
  props: {
    organization: {
      required: true,
      type: Object
    },
    hasCompleted: {
      required: true,
      type: Boolean
    },
  },
  data() {
    return {
      modalOpen: false,
    }
  }
}
</script>

<style scoped>

</style>